// alert-system.js - Premium Custom Design (Framework Independent)
// Improved: Spinner for all alerts, single event listener, cleaner code

let alertListenerAdded = false;

export const hideAlert = () => {
  const el = document.getElementById("notificationAlert");
  if (el) {
    el.style.opacity = "0";
    setTimeout(() => {
      if (el.parentElement) {
        el.parentElement.removeChild(el);
      }
    }, 300);
  }

  // Also remove any stacked alerts
  const stackedAlerts = document.querySelectorAll(".custom-alert-stack");
  stackedAlerts.forEach((alert) => {
    if (alert.parentElement) {
      alert.parentElement.removeChild(alert);
    }
  });
};

export const showAlert = (style, title, message) => {
  hideAlert();

  let msg;
  let code;
  const spinner = `<div class="alert-spinner"></div>`;
  let deleteBtn = "";

  if (style === "danger") {
    msg = message.message || message;
    code = message.statusCode;
  } else {
    msg = message;
  }

  // Only primary (loading) alerts have no close button
  if (style !== "primary") {
    deleteBtn = `<button class="alert-close-btn" aria-label="Fermer">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"/>
      </svg>
    </button>`;
  }

  // Color mapping
  const colorMap = {
    danger: {
      primary: "#dc2626",
      light: "#fee2e2",
      dark: "#b91c1c",
    },
    success: {
      primary: "#059669",
      light: "#d1fae5",
      dark: "#047857",
    },
    warning: {
      primary: "#d97706",
      light: "#fef3c7",
      dark: "#b45309",
    },
    info: {
      primary: "#2563eb",
      light: "#dbeafe",
      dark: "#1d4ed8",
    },
    primary: {
      primary: "#7c3aed",
      light: "#ede9fe",
      dark: "#6d28d9",
    },
  };

  const colors = colorMap[style] || colorMap.info;

  const markupAlert = `
    <div id="notificationAlert" class="custom-alert custom-alert-${style}" 
         style="--alert-color: ${colors.primary}; 
                --alert-light: ${colors.light}; 
                --alert-dark: ${colors.dark};">
      <div class="alert-content">
        <div class="alert-header">
          <div class="alert-header-left">
          <div class="alert-title">${title}</div>
            ${spinner}
          </div>
          ${deleteBtn}
        </div>
        <div class="alert-body">
          <strong>${msg}</strong>
        </div>
      </div>
    </div>
  `;

  // Inject styles if not already present
  if (!document.querySelector("#alert-styles")) {
    const styleElement = document.createElement("style");
    styleElement.id = "alert-styles";
    styleElement.textContent = getAlertStyles();
    document.head.appendChild(styleElement);
  }

  // Add global click listener once
  if (!alertListenerAdded) {
    document.addEventListener("click", (event) => {
      const closeBtn = event.target.closest(".alert-close-btn");
      if (closeBtn) {
        const alert = closeBtn.closest(".custom-alert, .custom-alert-stack");
        if (alert) {
          alert.style.opacity = "0";
          setTimeout(() => {
            if (alert.parentElement) {
              alert.parentElement.removeChild(alert);
            }
          }, 300);
        }
      }
    });
    alertListenerAdded = true;
  }

  document.body.insertAdjacentHTML("afterbegin", markupAlert);

  // Animate in
  setTimeout(() => {
    const alert = document.getElementById("notificationAlert");
    if (alert) {
      alert.classList.add("alert-show");
    }
  }, 10);

  // Auto hide after 9 seconds (except for primary/loading)
  if (style !== "primary") {
    setTimeout(() => {
      hideAlert();
    }, 3000);
  }

  // Special handling for code 417
  if (code === 417) {
    const signButton = document.getElementById("sign");
    if (signButton) {
      signButton.click();
    }
  }

  // Clear on page navigation
  window.addEventListener("pageshow", hideAlert);
};

// Helper function for all CSS styles
function getAlertStyles() {
  return `
    /* Custom Alert System - Framework Independent */
    .custom-alert {
      position: fixed;
      top: 24px;
      left: 50%;
      transform: translateX(-50%) translateY(-20px);
      min-width: 300px;
      max-width: 500px;
      width: 90%;
      z-index: 9999;
      opacity: 0;
      visibility: hidden;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    .custom-alert.alert-show {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(0);
    }
    
    .alert-content {
      background: white;
      border-radius: 16px;
      padding: 20px;
      box-shadow: 
        0 20px 40px rgba(0, 0, 0, 0.1),
        0 8px 16px rgba(0, 0, 0, 0.08),
        0 0 0 1px rgba(0, 0, 0, 0.04),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
      border-left: 4px solid var(--alert-color);
      position: relative;
      overflow: hidden;
    }
    
    .alert-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
    }
    
    .alert-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    
    .alert-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2937;
      line-height: 1.4;
    }
    
    .alert-close-btn {
      background: rgba(0, 0, 0, 0.05);
      border: none;
      width: 32px;
      height: 32px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #6b7280;
      transition: all 0.2s ease;
      flex-shrink: 0;
      padding: 0;
    }
    
    .alert-close-btn:hover {
      background: rgba(0, 0, 0, 0.1);
      color: #374151;
      transform: scale(1.05);
    }
    
    .alert-close-btn:active {
      transform: scale(0.95);
    }
    
    .alert-close-btn svg {
      width: 14px;
      height: 14px;
    }
    
    .alert-body {
      color: #4b5563;
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 8px;
    }
    
    .alert-body strong {
      font-weight: 500;
      color: #374151;
    }
    
    /* Spinner for all alerts */
    .alert-spinner {
      width: 20px;
      height: 20px;
      border: 3px solid var(--alert-light);
      border-top-color: var(--alert-color);
      border-radius: 50%;
      animation: alertSpinner 1s linear infinite;
      flex-shrink: 0;
    }
    
    /* Alert type specific adjustments */
    .custom-alert-danger .alert-content {
      border-left-color: #dc2626;
    }
    
    .custom-alert-success .alert-content {
      border-left-color: #059669;
    }
    
    .custom-alert-warning .alert-content {
      border-left-color: #d97706;
    }
    
    .custom-alert-info .alert-content {
      border-left-color: #2563eb;
    }
    
    .custom-alert-primary .alert-content {
      border-left-color: #7c3aed;
    }
    
    /* Animation keyframes */
    @keyframes alertSpinner {
      to {
        transform: rotate(360deg);
      }
    }
    
    /* Stack for multiple alerts */
    .custom-alert-stack {
      position: fixed;
      top: 24px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9998;
      width: 300px;
      pointer-events: none;
      transition: all 0.3s ease;
    }
    
    .custom-alert-stack .alert-content {
      pointer-events: auto;
      margin-bottom: 12px;
      transform: scale(0.95);
      opacity: 0.9;
    }
    
    /* Responsive */
    @media (max-width: 640px) {
      .custom-alert {
        width: 95%;
        min-width: unset;
        top: 16px;
      }
      
      .alert-content {
        padding: 16px;
      }
      
      .alert-title {
        font-size: 15px;
      }
      
      .alert-body {
        font-size: 13px;
      }
    }
    
    /* Dark mode support */
    @media (prefers-color-scheme: dark) {
      .alert-content {
        background: #1f2937;
        box-shadow: 
          0 20px 40px rgba(0, 0, 0, 0.3),
          0 8px 16px rgba(0, 0, 0, 0.25),
          0 0 0 1px rgba(255, 255, 255, 0.05);
      }
      
      .alert-title {
        color: #f9fafb;
      }
      
      .alert-body {
        color: #d1d5db;
      }
      
      .alert-body strong {
        color: #e5e7eb;
      }
      
      .alert-close-btn {
        background: rgba(255, 255, 255, 0.1);
        color: #9ca3af;
      }
      
      .alert-close-btn:hover {
        background: rgba(255, 255, 255, 0.15);
        color: #d1d5db;
      }
    }
    
    /* Print styles */
    @media print {
      .custom-alert {
        display: none !important;
      }
    }
  `;
}

// Stacked alerts feature (now with spinner instead of progress bar)
export const showStackedAlert = (style, title, message, position = 1) => {
  const stackId = `alert-stack-${Date.now()}`;

  let msg;
  if (style === "danger") {
    msg = message.message || message;
  } else {
    msg = message;
  }

  const colors = {
    danger: "#dc2626",
    success: "#059669",
    warning: "#d97706",
    info: "#2563eb",
    primary: "#7c3aed",
  };

  const markup = `
    <div id="${stackId}" class="custom-alert-stack" style="top: ${
      24 + position * 80
    }px;">
      <div class="alert-content" style="border-left-color: ${
        colors[style] || colors.info
      };">
        <div class="alert-header">
          <div class="alert-header-left">
            <div class="alert-spinner"></div>
            <div class="alert-title">${title}</div>
          </div>
          <button class="alert-close-btn" aria-label="Fermer">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
              <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"/>
            </svg>
          </button>
        </div>
        <div class="alert-body">
          <strong>${msg}</strong>
        </div>
      </div>
    </div>
  `;

  // Inject styles if needed
  if (!document.querySelector("#alert-styles")) {
    const styleElement = document.createElement("style");
    styleElement.id = "alert-styles";
    styleElement.textContent = getAlertStyles();
    document.head.appendChild(styleElement);
  }

  document.body.insertAdjacentHTML("afterbegin", markup);

  // Animate in
  setTimeout(() => {
    const alert = document.getElementById(stackId);
    if (alert) {
      alert.style.opacity = "1";
      alert.style.transform = "translateX(-50%) translateY(0)";
    }
  }, 10);

  // Auto dismiss
  setTimeout(() => {
    const alert = document.getElementById(stackId);
    if (alert) {
      alert.style.opacity = "0";
      setTimeout(() => {
        if (alert.parentElement) {
          alert.parentElement.removeChild(alert);
        }
      }, 300);
    }
  }, 9000);
};

// Toast-style notification (unchanged, no progress bar)
export const showToast = (style, message, duration = 3000) => {
  const toastId = `toast-${Date.now()}`;

  const colors = {
    danger: "#dc2626",
    success: "#059669",
    warning: "#d97706",
    info: "#2563eb",
    primary: "#7c3aed",
  };

  const markup = `
    <div id="${toastId}" class="custom-toast" 
         style="--toast-color: ${colors[style] || colors.info};">
      <div class="toast-content">
        <div class="toast-message">${message}</div>
      </div>
    </div>
  `;

  // Add toast styles if not present
  if (!document.querySelector("#toast-styles")) {
    const styleElement = document.createElement("style");
    styleElement.id = "toast-styles";
    styleElement.textContent = `
      .custom-toast {
        position: fixed;
        bottom: 24px;
        right: 24px;
        min-width: 200px;
        max-width: 350px;
        background: white;
        border-radius: 12px;
        padding: 14px 18px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        border-left: 3px solid var(--toast-color);
        z-index: 9997;
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      .custom-toast.toast-show {
        opacity: 1;
        transform: translateY(0);
      }
      
      .toast-message {
        color: #374151;
        font-size: 14px;
        line-height: 1.4;
      }
      
      @media (prefers-color-scheme: dark) {
        .custom-toast {
          background: #1f2937;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        }
        
        .toast-message {
          color: #f3f4f6;
        }
      }
      
      @media (max-width: 640px) {
        .custom-toast {
          left: 16px;
          right: 16px;
          bottom: 16px;
          max-width: none;
        }
      }
    `;
    document.head.appendChild(styleElement);
  }

  document.body.insertAdjacentHTML("beforeend", markup);

  // Animate in
  setTimeout(() => {
    const toast = document.getElementById(toastId);
    if (toast) {
      toast.classList.add("toast-show");
    }
  }, 10);

  // Auto dismiss
  setTimeout(() => {
    const toast = document.getElementById(toastId);
    if (toast) {
      toast.classList.remove("toast-show");
      setTimeout(() => {
        if (toast.parentElement) {
          toast.parentElement.removeChild(toast);
        }
      }, 300);
    }
  }, duration);
};

// Global functions for backward compatibility
window.hideAlert = hideAlert;
window.showAlert = showAlert;
window.showToast = showToast;
window.showStackedAlert = showStackedAlert;

// Auto-initialize on load
document.addEventListener("DOMContentLoaded", () => {
  // If there are any existing alerts from server-side, style them
  const existingAlerts = document.querySelectorAll(".message");
  existingAlerts.forEach((alert) => {
    // Optional: convert existing Bulma alerts to custom ones
  });
});
